import { render, staticRenderFns } from "./mainFnBodyFirst.vue?vue&type=template&id=46f23002&scoped=true&"
import script from "./mainFnBodyFirst.vue?vue&type=script&lang=js&"
export * from "./mainFnBodyFirst.vue?vue&type=script&lang=js&"
import style0 from "./mainFnBodyFirst.vue?vue&type=style&index=0&id=46f23002&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f23002",
  null
  
)

export default component.exports